// LICENSE_CODE ZON
'use strict'; /*jslint react:true*/
import React, {useState, useCallback, useEffect} from 'react';
import {useStore} from '@nanostores/react';
import date, {ms} from '/util/date.js';
import {$notifs} from '@pub/store/notifications.js';
import * as local_storage from '@pub/utils/local_storage.js';
import {Text} from '@pub/comp/text';
import {Button} from '@pub/comp/button';
import {Popup} from '@pub/comp/popup';
import {Countdown} from '@pub/comp/countdown';
import * as cns from './notifs_center.module.less';

const OPEN_BANNER_DELAY = ms.SEC*2;

const get_banner_tag = id=>`banner_${id.toLowerCase()}`;

const should_show_banner = id=>{
    const showed = local_storage.read(get_banner_tag(id));
    if (!showed)
        return true;
    return date()-date(showed)>ms.DAY;
};

const pick_banner = list=>{
    for (const i of list)
    {
        if (i.meta?.banner&&should_show_banner(i.id))
            return i;
    }
    return false;
};

const set_banner_showed = id=>{
    local_storage.write(get_banner_tag(id), date());
};

function Banner({opened, on_close}){
    return <Popup show={opened} hide_actions hide_header on_close={on_close}
      no_padding>
      <div className={cns.img_wrapper}>
      </div>
    </Popup>;
}

function Details({details, opened, on_close}){
    return <Popup show={opened} hide_actions on_close={on_close}
      title="Details">
      <div className={cns.details_wrapper}>
        <Text.m className={cns.details}>{details}</Text.m>
      </div>
    </Popup>;
}

function Notif({notif, on_banner, on_details}){
    const handle_banner = useCallback(()=>on_banner(notif),
        [notif, on_banner]);
    const handle_details = useCallback(()=>on_details(notif),
        [notif, on_details]);
    return <div className={cns.notif}>
      <div className={cns.notif_head}>
        <div className={cns.notif_row}>
          <Text.m bold>{notif.title}</Text.m>
          <Text.s tertiary>{notif.start}</Text.s>
        </div>
        <Text.m secondary className={cns.notif_text}>
          <span dangerouslySetInnerHTML={{__html: notif.brief||''}} />
        </Text.m>
        {!notif.meta?.no_countdown&&
          <div className={cns.counter}>
            <Countdown counter={notif.id} units={2} size="s"/>
          </div>
        }
      </div>
      <ul className={cns.actions}>
        {notif.meta?.banner&&<li>
          <Button on_click={handle_banner} size="s" view="link" left_shift
            color_scheme="accent">
            Show banner
          </Button>
        </li>}
        {notif.meta?.details&&<li>
          <Button on_click={handle_details} size="s" view="link" left_shift
            color_scheme="accent">
            Show details
          </Button>
        </li>}
      </ul>
    </div>;
}

function use_banner(field){
    const [opened, set_opened] = useState(null);
    const [data, set_data] = useState(null);
    const close_popup = useCallback(()=>set_opened(false), []);
    const open_popup = useCallback(o=>{
        if (o?.meta?.[field])
        {
            set_opened(true);
            set_data(o?.meta?.[field]);
        }
    }, []);
    return [data, opened, open_popup, close_popup];
}

function Modal({notifs, on_banner, on_details}){
    return <div className={cns.wrap}>
      <ul className={cns.list}>
        {!notifs.length&&<li>
          <Text.s mono secondary>No messages found</Text.s>
        </li>}
        {notifs.map(n=><li key={n.id}>
          <Notif notif={n} on_banner={on_banner} on_details={on_details}/>
        </li>)}
      </ul>
    </div>;
}

export function Notifs_center({className}){
    const list = useStore($notifs);
    const [show_popup, set_show_popup] = useState(false);
    const [banner, b_opened, open_b, close_b] = use_banner('banner');
    const [details, d_opened, open_d, close_d] = use_banner('details');
    const toggle_popup = useCallback(()=>set_show_popup(s=>!s), []);
    useEffect(()=>{
        const to_open = pick_banner(list);
        if (!to_open)
            return;
        const open_tm = setTimeout(()=>{
            open_b(to_open);
            set_banner_showed(to_open.id);
        }, OPEN_BANNER_DELAY);
        return ()=>{
            clearTimeout(open_tm);
        };
    }, [list]);
    return <>
      <Button className={className}
        on_click={toggle_popup} tip="Message Center" dot_count={list.length}
        ico="notification" size="s" color_scheme="tertiary" filled/>
      <Popup title="Message Center" show={show_popup} on_close={toggle_popup}
        hide_actions>
        <Modal notifs={list} on_banner={open_b} on_details={open_d}/>
      </Popup>
      <Banner banner={banner} opened={b_opened} on_close={close_b}/>
      <Details details={details} opened={d_opened} on_close={close_d}/>
    </>;
}
